var map = {
	"./ActiveShopComponent.vue": [
		4273,
		273
	],
	"./ConfirmationModalComponent.vue": [
		3361,
		361
	],
	"./NavBarComponent.vue": [
		822
	],
	"./RoomsComponent.vue": [
		595,
		595
	],
	"./ShopsComponent.vue": [
		497,
		497
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 7747;
module.exports = webpackAsyncContext;